import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-4" }
const _hoisted_2 = { class: "col-span-3 p-4" }
const _hoisted_3 = { class: "mb-6 text-4xl font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h2", { class: "mb-6 text-lg font-semibold" }, "Performance", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "mb-6 text-lg font-semibold" }, "Syllabus", -1)
const _hoisted_6 = { class: "p-4 bg-primary-dark" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h2", { class: "mb-6 text-lg font-semibold" }, "Recommended Events", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_event_grid = _resolveComponent("event-grid")
  const _component_syllabus = _resolveComponent("syllabus")
  const _component_recommendation_card_selector = _resolveComponent("recommendation-card-selector")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.student.firstName) + " " + _toDisplayString(_ctx.student.lastName), 1),
        _hoisted_4,
        _createVNode(_component_event_grid, {
          events: _ctx.events,
          class: "mb-6"
        }, null, 8, ["events"]),
        _hoisted_5,
        _createVNode(_component_syllabus)
      ]),
      _createVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_recommendation_card_selector, {
          recommendations: _ctx.recommendations,
          onSchedule: _ctx.scheduleEvent,
          onRemove: _ctx.removeEvent
        }, null, 8, ["recommendations", "onSchedule", "onRemove"])
      ])
    ])
  ]))
}